import React, { FunctionComponent } from 'react';
import { Company, DataCategory, DataValueCompanyPageTvs } from '../../../types/companyDetail';
import { CompanyDetailTvsChild } from '../../molecules/companyDetailTvsChild';

type Props = {
  tvIds: number[];
  company: Company;
  dataCategory: DataCategory;
  dataValue: DataValueCompanyPageTvs;
};

export const Presentation: FunctionComponent<Props> = ({
  tvIds,
  company,
  dataCategory,
  dataValue,
}) => {
  if (!tvIds || tvIds.length === 0) return null;

  return (
    <section className="company__page__recruitments css-slider">
      <div className="company__page__recruitments__header">
        <h2 className="company__page__recruitments__header--title">動画</h2>
        {company && (
          <a
            href={`/tvs/search?keyword=${company.name}`}
            className="company__page__recruitments__header--link gtm-button-view-count"
            data-event-name='button on screen'
            data-event="click"
            data-category={dataCategory}
            data-value={dataValue.moreSelfMovie}
          >
            すべての動画を見る
          </a>
        )}
      </div>
      <div className="company__page__recruitments__wrapper slides">
        {tvIds.map((id) => (
          <CompanyDetailTvsChild
            key={id}
            id={id}
            dataCategory={dataCategory}
            dataValue={dataValue}
          />
        ))}
      </div>
    </section>
  );
};
